
export default {
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initAnimation()
    })
  },
  methods: {
    initAnimation() {
      const gsap = this.$gsap
      const SplitText = this.$SplitText

      const mySplitText = new SplitText('.solutions-title', {
        type: 'words,chars',
      })
      const chars = mySplitText.chars

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: '.solutions-grid',
          start: 'top center',
        },
      })

      tl.from(chars, {
        opacity: 0,
        scale: 0,
        ease: 'back',
        stagger: 0.005,
      })
    },
  },
}
